// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const moment = require('moment');

moment.locale('en-US', {
  calendar: require('./english-calendar'),
  longDateFormat: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY LT',
    LLLL: 'MMMM D'
  }
}
);
